module.exports = __webpack_public_path__ + "static/downloadAppleStore-3c1a42ab8660f949982e598054a24d7a.png";